import { ShipmentAddress } from '@control-tower/platform-wms';

export enum FedexDocumentTypes {
    Label = 'Label',
    BillOfLading = 'BillOfLading',
    Other = 'Other',
    MergedLabelDocuments = 'MergedLabelDocuments',
    CommercialInvoice = 'CommercialInvoice',
}

export interface CpwShipmentPackage {
    weight?: string | null;
    box?: string | null;
    dimensions?: string | null;
    contentDescription?: string | null;
    contentItems?: ContentItem[] | null;
    totalQuantity?: number | null;
    value?: string | null;
}

export interface ContentItem {
    description: string;
    quantity: number;
}

export interface CpwShippingDetails {
    id?: string | null;
    shipTo?: ShipmentAddress | null;
    trackingNumber?: string | null;
    packages?: CpwShipmentPackage[] | null;
    service?: string | null;
    speed?: string | null;
    requestor?: string | null;
}
